import { useState } from "react";

import { PageLayout } from "pages/ui";
import { Validator } from "shared/api/cosmos/use-validators-query";

import { StakingCtx } from "../providers/staking-provider";
import { Banner } from "./banner";
import { MainScreen } from "./main/main";
import { StakingTerminal } from "./staking-terminal";
import { Statistic } from "./statistic";

export const Staking = () => {
  const [validator, setValidator] = useState<Validator | undefined>(undefined);

  return (
    <StakingCtx.Provider value={{ validator }}>
      <PageLayout title="Staking">
        <Banner className="mt-8" />
        <div className="mt-8 grid grid-cols-[minmax(358px,400px)_1fr] items-stretch gap-x-6">
          <aside className="grid grid-cols-2 gap-4">
            <Statistic info="some info" symbol="%" title="APY" value="1200" />
            <Statistic
              info="some info"
              symbol="GNET"
              title="Projected rewards"
              value="500"
            />
            <StakingTerminal
              className="col-span-full"
              onSelect={setValidator}
            />
          </aside>
          <MainScreen />
        </div>
      </PageLayout>
    </StakingCtx.Provider>
  );
};
